const TableResults = ({ totalItems }) => (
  <div className="table-results">
    {totalItems
      ? `Showing ${totalItems} result${totalItems === 1 ? "" : "s"}`
      : "Showing 0 results"}
  </div>
);

export default TableResults;
